import { faCircleInfo, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { Menu } from 'presentation/components/atoms/menu'
import { MenuItem } from 'presentation/components/atoms/menuItem'
import { Divider } from 'presentation/components/atoms/divider'
import { Icon } from 'presentation/components/atoms/Icon'
import { StyledNavLink } from './styles'
import { signOut } from 'store/modules/auth/actions'
import { useDispatch, useSelector } from 'react-redux'
import { FILE_CONTEXT, FILE_KIND, FILE_SUBCONTEXT } from '@/utils/constants'
import useService from 'main/hooks/useService'
import { getFile } from '@/services/filesServices'
import { pushNotification } from '@/store/modules/notification/actions'
import { download } from '@/utils/functionUtils'
import { Box } from 'presentation/components/atoms/box'
import { Typography } from 'presentation/components/atoms/typography'
import { Tooltip } from 'presentation/components/atoms/tooltip'

export const UserMenu = ({ destinations = [], anchorEl, id, open, onClose, onClick, hideTerm }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user.data)
  const [, downloadTermRequest] = useService(getFile, {
    onCompleted: (response) => {
      if (response.data?.length === 0)
        dispatch(
          pushNotification({
            type: 'error',
            content: response.data.message,
          }),
        )
      else download('data:application/pdf;base64,' + response.data.content, 'Termo de Adesão.pdf')
    },
  })
  const downloadTerm = () => {
    downloadTermRequest(
      `?context=${FILE_CONTEXT.RESALE}&subcontext=${FILE_SUBCONTEXT.TERM}&kind=${FILE_KIND.TERM}&ContextId=${user.resaleId}`,
    )
  }
  const renderUserInfo = () => {
    const renderText = (text, variant) => (
      <Tooltip title={text}>
        <Typography
          variant={variant}
          component='div'
          sx={{
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {text}
        </Typography>
      </Tooltip>
    )

    return [
      <Box
        key={'menuUserInfo'}
        onClick={(e) => e.stopPropagation()}
        sx={{
          padding: '16px',
          display: { md: 'none' },
        }}
      >
        {renderText(user?.user?.name, 'h4')}
        {renderText(user?.resale?.name, 'body')}
      </Box>,
      <Divider key={'menuUserInfoDivider'} light sx={{ display: { md: 'none' } }} />,
    ]
  }

  return (
    <Menu id={id} open={open} anchorEl={anchorEl} onClose={onClose} onClick={onClick}>
      {renderUserInfo()}
      {destinations.map((destination, index) => {
        return (
          <StyledNavLink key={`${index}_userMenuItem`} to={destination.pathname}>
            <MenuItem>
              <Icon icon={destination.icon} />
              {destination.displayName}
            </MenuItem>
          </StyledNavLink>
        )
      })}

      <Divider light />
      {hideTerm ? null : (
        <MenuItem sx={(theme) => ({ color: theme.palette.info.main })} onClick={() => downloadTerm()}>
          <Icon icon={faCircleInfo} />
          Termos e condições
        </MenuItem>
      )}
      <MenuItem sx={(theme) => ({ color: theme.palette.error.main })} onClick={() => dispatch(signOut())}>
        <Icon icon={faRightFromBracket} />
        Sair
      </MenuItem>
    </Menu>
  )
}
